module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"StaffID":"Staff ID"},"zh":{"StaffID":"员工ID"},"mm":{"StaffID":"၀န်ထမ်း ID"}}')
  delete Component.options._Ctor
}
